import { hasAnyPermission, hasPermission } from './crmPermissions';

export { hasAnyPermission, hasPermission };

export const QUOTE_CONTRACT_PERMISSIONS = {
  READ: 'quote_contract:read',
  CREATE: 'quote_contract:create',
  UPDATE: 'quote_contract:update',
  REVIEW: 'quote_contract:review',
  CONTRACT: 'quote_contract:contract',
  CHANGE_APPROVE: 'quote_contract:change_approve',
} as const;

export function canSeeQuoteContractMenu(
  permissions: readonly string[],
): boolean {
  return hasPermission(permissions, QUOTE_CONTRACT_PERMISSIONS.READ);
}
